import React from 'react';
import { FormattedIcon } from '../icon/formattedIcon';
import {socialMedia} from '../../utils/socialmedia';

// import styled
import {
    StyledContainer,
    StyledSocial,
    StyledSocialLink,
    StyledSocialList
}from './Footer_styled';

const Footer = () => {
  

    return (
        <StyledContainer>
            <StyledSocial>
                <StyledSocialList>
     
                            <li >
                                <StyledSocialLink 
                                target="_blank"
                                rel="nofollow noopener noreferrer"
                                href={socialMedia.github}>
                                    <FormattedIcon name="GitHub" />
                                </StyledSocialLink>
                            </li>

                    <li >
                        <StyledSocialLink 
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        href={socialMedia.linkedin}>
                            <FormattedIcon name="Linkedin" />
                        </StyledSocialLink>
                    </li>

                    <li >
                        <StyledSocialLink 
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        href={socialMedia.instagram}>
                            <FormattedIcon name="Instagram" />
                        </StyledSocialLink>
                    </li>

                    <li >
                        <StyledSocialLink 
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        href={socialMedia.twitter}>
                            <FormattedIcon name="Twitter" />
                        </StyledSocialLink>
                    </li>

                    <li >
                        <StyledSocialLink 
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        href={socialMedia.facebook}>
                            <FormattedIcon name="Facebook" />
                        </StyledSocialLink>
                    </li>

                    <li >
                        <StyledSocialLink 
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        href={socialMedia.skype}>
                            <FormattedIcon name="Skype" />
                        </StyledSocialLink>
                    </li>

                    <li >
                        <StyledSocialLink 
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        href={socialMedia.telegram}>
                            <FormattedIcon name="Telegram" />
                        </StyledSocialLink>
                    </li>
                        
                </StyledSocialList>
            </StyledSocial>
        </StyledContainer>
    );
};



export default Footer;
